module.exports = __webpack_public_path__ + "img/papas con tenders.0003957e.jpeg";